/* qtrat.net — تنسيق عرض السعر
   1) خانتان عشريتان بدل ثلاث: 9.000 -> 9.00 و 19.500 -> 19.50
      يُحذف الصفر الأخير فقط. أي سعر خانته الثالثة ليست صفراً (9.755) يُترك كما هو
      — فلا يُعرض أي رقم مخالف للسعر الحقيقي أبداً.
   2) JOD -> JD لاختصار رمز العملة.
   ملاحظة: صفحة الدفع تبقى بثلاث خانات لأنها من Shopify مباشرة ولا يمكن التدخل فيها. */
(function () {
  var SEL = 'hdt-money,.hdt-money,hdt-price,hdt-compare-at-price,.hdt-price,.hdt-price-wrapp,' +
            '.hdt-cart__total,.hdt-cart-drawer__total,.hdt-subtotal,.hdt-total,.hdt-totals,' +
            '.price,.money,[data-money],[data-price],.hdt-free-shipping,.hdt-fs-bar';
  var DEC = /(\d)\.(\d{2})0(?!\d)/g;
  var CODE = /\bJOD\b/g;

  function fixText(node) {
    var v = node.nodeValue;
    if (!v) return;
    var out = v;
    if (out.indexOf('.') > -1) out = out.replace(DEC, '$1.$2');
    if (out.indexOf('JOD') > -1) out = out.replace(CODE, 'JD');
    if (out !== v) node.nodeValue = out;
  }

  function fixEl(el) {
    if (!el || el.nodeType !== 1) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), n;
    while ((n = walker.nextNode())) fixText(n);
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    try { if (root.matches && root.matches(SEL)) fixEl(root); } catch (e) {}
    var list = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    for (var i = 0; i < list.length; i++) fixEl(list[i]);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; scan(document.body); });
  }

  function start() {
    scan(document.body);
    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) {}
    ['cart:updated', 'cart:refresh', 'variant:change', 'hdt:cart:updated', 'shopify:section:load']
      .forEach(function (ev) { document.addEventListener(ev, schedule); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
